// src/store/slices/clinicSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { clinicService } from "../../services/api/clinicService";
import { IClinic } from "../../types/clinic";

interface ClinicState {
  currentClinic: IClinic | null;
  loading: boolean;
  error: string | null;
}

const initialState: ClinicState = {
  currentClinic: null,
  loading: false,
  error: null,
};

export const fetchClinicById = createAsyncThunk(
  "clinic/fetchById",
  async (clinicId: string, { rejectWithValue }) => {
    try {
      const clinic = await clinicService.getClinicById(clinicId);
      return clinic;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch clinic"
      );
    }
  }
);

export const fetchClinicContactInfo = createAsyncThunk(
  "clinic/fetchContactInfo",
  async (clinicId: string, { rejectWithValue }) => {
    try {
      const contactInfo = await clinicService.getClinicContactInfo(clinicId);
      return contactInfo;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch contact information"
      );
    }
  }
);

const clinicSlice = createSlice({
  name: "clinic",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClinicById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClinicById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentClinic = action.payload;
      })
      .addCase(fetchClinicById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchClinicContactInfo.fulfilled, (state, action) => {
        if (state.currentClinic) {
          state.currentClinic = {
            ...state.currentClinic,
            ...action.payload,
          };
        }
      });
  },
});

export default clinicSlice.reducer;
